import { paymentsClient } from './clients';
import { catchAndRethrowSensitiveNetworkError
// @ts-expect-error Untyped module
} from 'crm_data/bCommerce/monitoring/errorUtils';
import { DISCOUNT_CODE_NOT_VALID } from '../constants/ValidationErrors';
export const fetchBuyerOverridesSubtotals = ({
  buyerOverrides,
  paymentSessionId,
  taxCalculationId,
  paymentMethod
}) => paymentsClient.post(`payments-checkout/v1/checkout-sessions/${paymentSessionId}/subtotals`, {
  data: {
    buyerOverrides,
    taxCalculationId,
    paymentMethod
  }
}).catch(e => {
  // We don't want to send a Sentry error when a discount code is not valid
  if (JSON.parse(e.data).subCategory !== DISCOUNT_CODE_NOT_VALID) {
    catchAndRethrowSensitiveNetworkError(e);
  }
  throw e;
});
export const fetchBuyerOverridesPreviewSubtotals = ({
  buyerOverrides,
  currencyCode,
  discount,
  adjustments,
  lineItems,
  portalId,
  paymentMethod,
  checkoutFees
}) => paymentsClient.post('payments-checkout/v1/checkout-session-previews/subtotals', {
  query: {
    portalId
  },
  data: {
    buyerOverrides,
    currencyCode,
    discount,
    lineItems,
    adjustments,
    paymentMethod,
    checkoutFees
  }
}).catch(e => {
  // We don't want to send a Sentry error when a discount code is not valid
  if (JSON.parse(e.data).subCategory !== DISCOUNT_CODE_NOT_VALID) {
    catchAndRethrowSensitiveNetworkError(e);
  }
  throw e;
});